// API Configuration
export const API_BASE_URL = 'https://naatilab.com';
const WS_BASE_URL = (API_BASE_URL.replace(/^http/, 'ws'));

//
// API Configuration
// export const API_BASE_URL = 'https://naatilab.com';
// const WS_BASE_URL = (API_BASE_URL.replace(/^http/, 'ws'));


export const API_ENDPOINTS = {
  // Realtime Speech-to-Text WebSocket
  REALTIME_STT_WS: `${WS_BASE_URL}/ws/realtime-stt/`,
  REGISTER: `${API_BASE_URL}/api/register/`,
  LOGIN: `${API_BASE_URL}/api/login/`,
  LOGOUT: `${API_BASE_URL}/api/logout/`,
  PROFILE: `${API_BASE_URL}/api/profile/`,
  PLATFORM_SETTINGS_PUBLIC: `${API_BASE_URL}/api/platform-settings/`,
  ADMIN_PLATFORM_SETTINGS: `${API_BASE_URL}/api/admin/platform-settings/`,
  HOME_PAGE_CONTENT: `${API_BASE_URL}/api/home-page-content/`,
  ADMIN_HOME_PAGE_CONTENT: `${API_BASE_URL}/api/admin/home-page-content/`,
  // Material Management (Admin)
  MATERIAL_UPLOAD: `${API_BASE_URL}/api/audio/admin/system-audio/upload/`,
  MATERIAL_LIST: `${API_BASE_URL}/api/audio/admin/system-audio/`,
  MATERIAL_DELETE: (id: number) => `${API_BASE_URL}/api/audio/admin/system-audio/${id}/`,
  MATERIAL_UPDATE: (id: number) => `${API_BASE_URL}/api/audio/admin/system-audio/${id}/update/`,
  AUDIO_CONTENT: (id: number) => `${API_BASE_URL}/api/audio/admin/system-audio/${id}/content/`,
  AUDIO_GENERATE_TRANSLATIONS: (id: number) => `${API_BASE_URL}/api/audio/admin/system-audio/${id}/generate-translations/`,
  AUDIO_SAVE_TRANSLATIONS: (id: number) => `${API_BASE_URL}/api/audio/admin/system-audio/${id}/save-translations/`,
  // Lab (Admin - ElevenLabs TTS)
  LAB_VOICES: `${API_BASE_URL}/api/audio/admin/lab/voices/`,
  LAB_GENERATE: `${API_BASE_URL}/api/audio/admin/lab/generate/`,
  LAB_SAVE: `${API_BASE_URL}/api/audio/admin/lab/save/`,
  LAB_ITEMS: `${API_BASE_URL}/api/audio/admin/lab/items/`,
  // Structural Segments (Admin)
  STRUCTURAL_SEGMENTS: `${API_BASE_URL}/api/audio/admin/structural-segments/`,
  STRUCTURAL_SEGMENT_DETAIL: (id: number) => `${API_BASE_URL}/api/audio/admin/structural-segments/${id}/`,
  STRUCTURAL_SEGMENT_ADD_AUDIO: (id: number) => `${API_BASE_URL}/api/audio/admin/structural-segments/${id}/add-audio/`,
  STRUCTURAL_SEGMENT_AUDIO_DETAIL: (segmentId: number, audioId: number) => `${API_BASE_URL}/api/audio/admin/structural-segments/${segmentId}/audios/${audioId}/`,
  // Structural Segments (Public - for regular users)
  PUBLIC_STRUCTURAL_SEGMENTS: `${API_BASE_URL}/api/audio/structural-segments/`,
  PUBLIC_STRUCTURAL_SEGMENT_DETAIL: (id: number) => `${API_BASE_URL}/api/audio/structural-segments/${id}/`,
  CHECK_SEGMENT_COMPLETION: (id: number) => `${API_BASE_URL}/api/audio/structural-segments/${id}/completion/`,
  BATCH_SEGMENT_COMPLETION: `${API_BASE_URL}/api/audio/structural-segments/completion/batch/`,
  // User Recordings
  UPLOAD_RECORDING: `${API_BASE_URL}/api/audio/upload/`,
  REGISTER_PRACTICE_SESSION: `${API_BASE_URL}/api/audio/practice-session/`,
  MOCK_SUBMIT: `${API_BASE_URL}/api/audio/mock-submit/`,
  // Audio Stream
  STREAM_AUDIO: (id: number) => `${API_BASE_URL}/api/audio/stream/${id}/`,
  AUTOPLAY_CHIME: `${API_BASE_URL}/api/audio/autoplay-chime/`,
  ADMIN_AUTOPLAY_CHIME: `${API_BASE_URL}/api/audio/admin/autoplay-chime/`,
  // Subscription Management (Admin)
  SUBSCRIPTIONS_LIST: `${API_BASE_URL}/api/subscriptions/`,
  SUBSCRIPTIONS_CREATE: `${API_BASE_URL}/api/subscriptions/create/`,
  SUBSCRIPTION_DETAIL: (id: number) => `${API_BASE_URL}/api/subscriptions/${id}/`,
  SUBSCRIPTION_UPDATE: (id: number) => `${API_BASE_URL}/api/subscriptions/${id}/update/`,
  SUBSCRIPTION_DELETE: (id: number) => `${API_BASE_URL}/api/subscriptions/${id}/delete/`,
  SUBSCRIPTION_STATUS: `${API_BASE_URL}/api/subscription/status/`,
  SUBSCRIPTION_PURCHASE_SUMMARY: `${API_BASE_URL}/api/subscription-purchase/summary/`,
  SUBSCRIPTION_PURCHASE_REQUESTS: `${API_BASE_URL}/api/subscription-purchase/requests/`,
  SUBSCRIPTION_PURCHASE_REQUEST_DETAIL: (id: number) =>
    `${API_BASE_URL}/api/subscription-purchase/requests/${id}/`,
  SUBSCRIPTION_PURCHASE_REQUEST_MESSAGES: (id: number) =>
    `${API_BASE_URL}/api/subscription-purchase/requests/${id}/messages/`,
  SUBSCRIPTION_PURCHASE_REQUEST_CANCEL: (id: number) =>
    `${API_BASE_URL}/api/subscription-purchase/requests/${id}/cancel/`,
  SUBSCRIPTION_PURCHASE_ATTACHMENT: (requestId: number, attachmentId: number) =>
    `${API_BASE_URL}/api/subscription-purchase/requests/${requestId}/attachments/${attachmentId}/`,
  ADMIN_SUBSCRIPTION_PURCHASE_CONFIG: `${API_BASE_URL}/api/admin/subscription-purchase/config/`,
  ADMIN_SUBSCRIPTION_PURCHASE_REQUEST_STATS: `${API_BASE_URL}/api/admin/subscription-purchase/requests/stats/`,
  ADMIN_SUBSCRIPTION_PURCHASE_REQUESTS: `${API_BASE_URL}/api/admin/subscription-purchase/requests/`,
  ADMIN_SUBSCRIPTION_PURCHASE_REQUEST_DETAIL: (id: number) =>
    `${API_BASE_URL}/api/admin/subscription-purchase/requests/${id}/`,
  ADMIN_SUBSCRIPTION_PURCHASE_REQUEST_REPLY: (id: number) =>
    `${API_BASE_URL}/api/admin/subscription-purchase/requests/${id}/reply/`,
  ADMIN_SUBSCRIPTION_PURCHASE_REQUEST_APPROVE: (id: number) =>
    `${API_BASE_URL}/api/admin/subscription-purchase/requests/${id}/approve/`,
  ADMIN_SUBSCRIPTION_PURCHASE_REQUEST_REJECT: (id: number) =>
    `${API_BASE_URL}/api/admin/subscription-purchase/requests/${id}/reject/`,
  ADMIN_USERS_LIST: `${API_BASE_URL}/api/admin/users/`,
  ADMIN_USERS_STATS: `${API_BASE_URL}/api/admin/users/stats/`,
  ADMIN_USER_UPDATE: (id: number) => `${API_BASE_URL}/api/admin/users/${id}/`,
  USERS_SEARCH: `${API_BASE_URL}/api/users/search/`,
  // Podcasts (Public - for authenticated users)
  PODCASTS_LIST: `${API_BASE_URL}/api/audio/podcasts/`,
  PODCAST_DETAIL: (id: number) => `${API_BASE_URL}/api/audio/podcasts/${id}/`,
  PODCAST_INCREMENT_VIEWS: (id: number) => `${API_BASE_URL}/api/audio/podcasts/${id}/increment-views/`,
  PODCAST_STREAM: (id: number) => `${API_BASE_URL}/api/audio/podcasts/${id}/stream/`,
  PODCAST_THUMBNAIL: (id: number) => `${API_BASE_URL}/api/audio/podcasts/${id}/thumbnail/`,
  PODCAST_WATCH_PROGRESS: (id: number) => `${API_BASE_URL}/api/audio/podcasts/${id}/progress/`,
  // Admin - Podcast Management
  ADMIN_PODCASTS_LIST: `${API_BASE_URL}/api/audio/admin/podcasts/`,
  ADMIN_PODCAST_DETAIL: (id: number) => `${API_BASE_URL}/api/audio/admin/podcasts/${id}/`,
  // Booking Services (Public - for authenticated users)
  BOOKING_SERVICES_LIST: `${API_BASE_URL}/api/audio/booking-services/`,
  /** Proxied image for <img src> (append ?token= like podcast thumbnail). */
  BOOKING_SERVICE_IMAGE: (id: number) => `${API_BASE_URL}/api/audio/booking-services/${id}/image/`,
  BOOKING_REQUEST_CREATE: `${API_BASE_URL}/api/audio/booking-requests/`,
  // Admin - Booking Management
  ADMIN_BOOKING_SERVICES: `${API_BASE_URL}/api/audio/admin/booking-services/`,
  ADMIN_BOOKING_SERVICE_DETAIL: (id: number) => `${API_BASE_URL}/api/audio/admin/booking-services/${id}/`,
  ADMIN_BOOKING_REQUESTS: `${API_BASE_URL}/api/audio/admin/booking-requests/`,
  ADMIN_BOOKING_REQUEST_DETAIL: (id: number) => `${API_BASE_URL}/api/audio/admin/booking-requests/${id}/`,
  // Online Courses (user)
  ONLINE_COURSES_LIST: `${API_BASE_URL}/api/audio/online-courses/`,
  ONLINE_COURSE_IMAGE: (id: number) => `${API_BASE_URL}/api/audio/online-courses/${id}/image/`,
  COURSE_ENROLLMENT_CREATE: `${API_BASE_URL}/api/audio/course-enrollments/`,
  // Online Courses (admin)
  ADMIN_ONLINE_COURSES: `${API_BASE_URL}/api/audio/admin/online-courses/`,
  ADMIN_ONLINE_COURSE_DETAIL: (id: number) => `${API_BASE_URL}/api/audio/admin/online-courses/${id}/`,
  ADMIN_COURSE_ENROLLMENTS: `${API_BASE_URL}/api/audio/admin/course-enrollments/`,
  ADMIN_COURSE_ENROLLMENT_DETAIL: (id: number) => `${API_BASE_URL}/api/audio/admin/course-enrollments/${id}/`,
  // User Statistics
  USER_STATS: `${API_BASE_URL}/api/audio/user-stats/`,
  USER_RECENT_ACTIVITY: `${API_BASE_URL}/api/audio/user-recent-activity/`,
  // Admin - Site Statistics
  ADMIN_STATS: `${API_BASE_URL}/api/audio/admin/stats/`,
  ADMIN_TEST_RULES_PDFS: `${API_BASE_URL}/api/audio/admin/test-rules-pdfs/`,
  ADMIN_TEST_RULES_PDF_UPLOAD: `${API_BASE_URL}/api/audio/admin/test-rules-pdfs/upload/`,
  PDF_DOWNLOAD: (filename: string) =>
    `${API_BASE_URL}/api/pdfs/${encodeURIComponent(filename)}/`,
  // Admin - User Management
  ADMIN_USER_DETAILS: (id: number) => `${API_BASE_URL}/api/audio/admin/users/${id}/`,
  // Tutorial
  TUTORIAL_COMPLETE: `${API_BASE_URL}/api/tutorial/complete/`,
  // Dialogue Categories (Public - for authenticated users)
  DIALOGUE_CATEGORIES_LIST: `${API_BASE_URL}/api/audio/dialogue-categories/`,
  DIALOGUES_IN_CATEGORY: (categoryId: number) => `${API_BASE_URL}/api/audio/dialogue-categories/${categoryId}/dialogues/`,
  DIALOGUE_DETAIL: (dialogueId: number) => `${API_BASE_URL}/api/audio/dialogues/${dialogueId}/`,
  DIALOGUE_USER_PROGRESS: (dialogueId: number) => `${API_BASE_URL}/api/audio/dialogues/${dialogueId}/user-progress/`,
  CHECK_DIALOGUE_COMPLETION: (dialogueId: number) => `${API_BASE_URL}/api/audio/dialogues/${dialogueId}/completion/`,
  BATCH_DIALOGUE_COMPLETION: `${API_BASE_URL}/api/audio/dialogues/completion/batch/`,
  MOCK_DIALOGUES_LIST: `${API_BASE_URL}/api/audio/mock-dialogues/`,
  MOCK_MY_SUBMISSIONS: `${API_BASE_URL}/api/audio/my-mock-submissions/`,
  MOCK_RESULT: (id: number) => `${API_BASE_URL}/api/audio/mock-result/${id}/`,
  MOCK_CREDITS_SUMMARY: `${API_BASE_URL}/api/audio/mock-credits/summary/`,
  MOCK_CREDIT_REQUESTS: `${API_BASE_URL}/api/audio/mock-credit-requests/`,
  MOCK_CREDIT_REQUEST_DETAIL: (id: number) => `${API_BASE_URL}/api/audio/mock-credit-requests/${id}/`,
  MOCK_CREDIT_REQUEST_MESSAGES: (id: number) => `${API_BASE_URL}/api/audio/mock-credit-requests/${id}/messages/`,
  MOCK_CREDIT_REQUEST_CANCEL: (id: number) => `${API_BASE_URL}/api/audio/mock-credit-requests/${id}/cancel/`,
  MOCK_CREDIT_ATTACHMENT: (requestId: number, attachmentId: number) =>
    `${API_BASE_URL}/api/audio/mock-credit-requests/${requestId}/attachments/${attachmentId}/`,
  ADMIN_MOCK_CREDIT_REQUESTS: `${API_BASE_URL}/api/audio/admin/mock-credit-requests/`,
  ADMIN_MOCK_CREDIT_REQUEST_STATS: `${API_BASE_URL}/api/audio/admin/mock-credit-requests/stats/`,
  ADMIN_MOCK_CREDIT_REQUEST_DETAIL: (id: number) => `${API_BASE_URL}/api/audio/admin/mock-credit-requests/${id}/`,
  ADMIN_MOCK_CREDIT_REQUEST_REPLY: (id: number) => `${API_BASE_URL}/api/audio/admin/mock-credit-requests/${id}/reply/`,
  ADMIN_MOCK_CREDIT_REQUEST_APPROVE: (id: number) => `${API_BASE_URL}/api/audio/admin/mock-credit-requests/${id}/approve/`,
  ADMIN_MOCK_CREDIT_REQUEST_REJECT: (id: number) => `${API_BASE_URL}/api/audio/admin/mock-credit-requests/${id}/reject/`,
  ADMIN_USER_MOCK_CREDITS: (userId: number) => `${API_BASE_URL}/api/audio/admin/users/${userId}/mock-credits/`,
  // Admin - Dialogue Category Management
  ADMIN_DIALOGUE_CATEGORIES: `${API_BASE_URL}/api/audio/admin/dialogue-categories/`,
  ADMIN_DIALOGUE_CATEGORY_DETAIL: (id: number) => `${API_BASE_URL}/api/audio/admin/dialogue-categories/${id}/`,
  ADMIN_DIALOGUES_IN_CATEGORY: (categoryId: number) => `${API_BASE_URL}/api/audio/admin/dialogue-categories/${categoryId}/dialogues/`,
  ADMIN_CATEGORY_DIALOGUE_DETAIL: (dialogueId: number) => `${API_BASE_URL}/api/audio/admin/dialogues/${dialogueId}/`,
  ADMIN_DIALOGUE_PARTS: (dialogueId: number) =>
    `${API_BASE_URL}/api/audio/admin/dialogues/${dialogueId}/parts/`,
  ADMIN_DIALOGUE_PART_DETAIL: (dialogueId: number, partId: number) =>
    `${API_BASE_URL}/api/audio/admin/dialogues/${dialogueId}/parts/${partId}/`,
  ADMIN_DIALOGUE_PART_BULK_CONTENT: (dialogueId: number, partId: number) =>
    `${API_BASE_URL}/api/audio/admin/dialogues/${dialogueId}/parts/${partId}/bulk-content/`,
  ADMIN_DIALOGUE_ADD_AUDIO: (dialogueId: number) => `${API_BASE_URL}/api/audio/admin/dialogues/${dialogueId}/add-audio/`,
  ADMIN_DIALOGUE_AUDIO_DETAIL: (dialogueId: number, linkId: number) =>
    `${API_BASE_URL}/api/audio/admin/dialogues/${dialogueId}/audios/${linkId}/`,
  // Admin - Mock Grading
  ADMIN_MOCK_SUBMISSIONS: `${API_BASE_URL}/api/audio/admin/mock-submissions/`,
  ADMIN_MOCK_SUBMISSION_DETAIL: (id: number) => `${API_BASE_URL}/api/audio/admin/mock-submissions/${id}/`,
  ADMIN_MOCK_SUBMISSION_SUBMIT_RESULTS: (id: number) => `${API_BASE_URL}/api/audio/admin/mock-submissions/${id}/submit-results/`,
  // NAATI AI Support
  SUPPORT_CONFIG: `${API_BASE_URL}/api/support/config/`,
  SUPPORT_CHAT: `${API_BASE_URL}/api/support/chat/`,
  SUPPORT_CONVERSATION: (id: number) => `${API_BASE_URL}/api/support/conversations/${id}/`,
  SUPPORT_ESCALATE: (id: number) => `${API_BASE_URL}/api/support/conversations/${id}/escalate/`,
  ADMIN_SUPPORT_CONFIG: `${API_BASE_URL}/api/admin/support/config/`,
  ADMIN_SUPPORT_KNOWLEDGE: `${API_BASE_URL}/api/admin/support/knowledge/`,
  ADMIN_SUPPORT_KNOWLEDGE_DETAIL: (id: number) => `${API_BASE_URL}/api/admin/support/knowledge/${id}/`,
  ADMIN_SUPPORT_KNOWLEDGE_REFRESH: (id: number) =>
    `${API_BASE_URL}/api/admin/support/knowledge/${id}/refresh-embedding/`,
  ADMIN_SUPPORT_KNOWLEDGE_REINDEX: `${API_BASE_URL}/api/admin/support/knowledge/reindex-all/`,
  ADMIN_SUPPORT_CONVERSATIONS: `${API_BASE_URL}/api/admin/support/conversations/`,
  ADMIN_SUPPORT_CONVERSATION_DETAIL: (id: number) =>
    `${API_BASE_URL}/api/admin/support/conversations/${id}/`,
  ADMIN_SUPPORT_CONVERSATION_CLOSE: (id: number) =>
    `${API_BASE_URL}/api/admin/support/conversations/${id}/close/`,
  ADMIN_SUPPORT_OPENAI_STATUS: `${API_BASE_URL}/api/admin/support/openai/status/`,
};

// Get token from localStorage
export const getToken = (): string | null => {
  return localStorage.getItem('token');
};

/**
 * Stream URL for HTML media elements (`<audio>`, `new Audio()`), which cannot send `Authorization`.
 * Matches backend `stream_audio` optional `?token=` (same idea as podcast video stream).
 */
export const getAuthenticatedAudioStreamUrl = (audioId: number): string | null => {
  const token = getToken();
  if (!token) return null;
  const base = API_ENDPOINTS.STREAM_AUDIO(audioId);
  const sep = base.includes('?') ? '&' : '?';
  return `${base}${sep}token=${encodeURIComponent(token)}`;
};

/** Attachment URL for mock credit purchase tickets (receipt images). */
export const getMockCreditAttachmentUrl = (requestId: number, attachmentId: number): string | null => {
  const token = getToken();
  if (!token) return null;
  const base = API_ENDPOINTS.MOCK_CREDIT_ATTACHMENT(requestId, attachmentId);
  return `${base}?token=${encodeURIComponent(token)}`;
};

/** Attachment URL for subscription purchase tickets (receipt images). */
export const getSubscriptionPurchaseAttachmentUrl = (requestId: number, attachmentId: number): string | null => {
  const token = getToken();
  if (!token) return null;
  const base = API_ENDPOINTS.SUBSCRIPTION_PURCHASE_ATTACHMENT(requestId, attachmentId);
  return `${base}?token=${encodeURIComponent(token)}`;
};

// Set token in localStorage
export const setToken = (token: string): void => {
  localStorage.setItem('token', token);
};

// Remove token from localStorage
export const removeToken = (): void => {
  localStorage.removeItem('token');
};

// Check if user is authenticated
export const isAuthenticated = (): boolean => {
  return !!getToken();
};

